import styled from 'styled-components';

import { HideIcon, VisualizationIcon } from '@genially/icons';

import BaseInput from '../BaseInput/BaseInput';
import { StyledInput } from '../Common.styled';

interface StyledBaseInputProps {
  $showPassword: boolean;
}

export const StyledBaseInput = styled(BaseInput)<StyledBaseInputProps>(
  ({ $showPassword }) => ({
    [StyledInput]: {
      fontFamily: $showPassword ? undefined : 'verdana',
      fontWeight: $showPassword ? undefined : 'bold',
    },
  }),
);

export const StyledHideIcon = styled(HideIcon)(({ theme: { size } }) => ({
  width: size.units(2),
  height: size.units(2),
}));

export const StyledVisualizationIcon = styled(VisualizationIcon)(
  ({ theme: { size } }) => ({
    width: size.units(2),
    height: size.units(2),
  }),
);
